/**
 * /referrals — Refer & Earn page (referral code + referral status).
 *
 * Sits under _protected so only authenticated customers can reach it.
 */
import { createFileRoute } from '@tanstack/react-router';
import { ReferralsPage } from '@/features/referrals/referrals-page';

export const Route = createFileRoute('/_protected/referrals')({
  component: ReferralsPage,
});
